import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c94d41b6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Não há nenhum comentário por aqui", -1))
const _hoisted_2 = { class: "course-track" }
const _hoisted_3 = { class: "course-track__content" }
const _hoisted_4 = { class: "course-track__title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Comment = _resolveComponent("Comment")!
  const _component_content_fallback = _resolveComponent("content-fallback")!
  const _component_CommentsModal = _resolveComponent("CommentsModal")!
  const _component_ModalIntroductoryContent = _resolveComponent("ModalIntroductoryContent")!
  const _component_course = _resolveComponent("course")!
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_carousel = _resolveComponent("carousel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isCommentsModalOpen)
      ? (_openBlock(), _createBlock(_component_CommentsModal, {
          key: 0,
          onCloseCommentsModal: _ctx.closeCommentsModal,
          title: _ctx.commentModalTitle
        }, {
          default: _withCtx(() => [
            (_ctx.comments.length)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.comments, (comment, index) => {
                  return (_openBlock(), _createBlock(_component_Comment, {
                    key: index,
                    "user-name": comment.userName,
                    comment: comment.message,
                    date: _ctx.toLocaleDateTime(comment.createAt),
                    stars: comment.rating,
                    "user-image": comment.userImage,
                    "content-name": comment.contentName
                  }, null, 8, ["user-name", "comment", "date", "stars", "user-image", "content-name"]))
                }), 128))
              : (_openBlock(), _createBlock(_component_content_fallback, { key: 1 }, {
                  default: _withCtx(() => [
                    _hoisted_1
                  ]),
                  _: 1
                }))
          ]),
          _: 1
        }, 8, ["onCloseCommentsModal", "title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.openModalIntroductoryContent && _ctx.course.introductoryContent)
        ? (_openBlock(), _createBlock(_component_ModalIntroductoryContent, {
            key: 0,
            onClose: _ctx.closeModalIntroductoryContent,
            "introductory-content": _ctx.course.introductoryContent
          }, null, 8, ["onClose", "introductory-content"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.courseTrack.title), 1),
        (_ctx.courses.length)
          ? (_openBlock(), _createBlock(_component_carousel, {
              key: 0,
              settings: _ctx.settings,
              breakpoints: _ctx.breakpoints,
              class: "carousel-course"
            }, {
              addons: _withCtx(() => [
                _createVNode(_component_Navigation)
              ]),
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, index) => {
                  return (_openBlock(), _createBlock(_component_Slide, {
                    key: 'course' + index
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_course, {
                        course: course,
                        onLoadCourseCommentsModal: ($event: any) => (_ctx.loadCourseCommentsModal(course)),
                        onOpenIntroductoryContent: ($event: any) => (_ctx.openIntroductoryContent(course)),
                        onOpenCourse: ($event: any) => (
              _ctx.$router.push({ name: 'course', params: { course_id: course.id } })
            )
                      }, null, 8, ["course", "onLoadCourseCommentsModal", "onOpenIntroductoryContent", "onOpenCourse"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }, 8, ["settings", "breakpoints"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}